import { combineReducers, configureStore } from "@reduxjs/toolkit";
import bookingReducer from "../features/bookingSlice";
import storage from "redux-persist/lib/storage";
import auth from "./auth";
import { persistReducer, persistStore } from "redux-persist";

const rootReducer = combineReducers({
  booking: bookingReducer,
  auth: auth,
});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});
export const persist = persistStore(store);
